import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {city_field_change} from "../../redux/actions";

export const CityFrom = () => {
    const dispatch = useDispatch()
    const value = useSelector(state => state.app.fields.cityFrom.value)
    const error = useSelector(state => state.app.fields.cityFrom.error)
    const autocomplite = useSelector(state => state.app.fields.cityFrom.autocomplite)
    const autocomplite_data = useSelector(state => state.app.autocomplite.data)

    return (
        <React.Fragment>
            <label htmlFor="city_from">Откуда</label>
            <div className="autocomplete">
                <input type="text" id="city_from" className={'front-calc__city_input text-input' + (error ? ' error' : '')}
                       name="city_from" placeholder="Город, страна"
                       value={value}
                       onChange={(e) => dispatch(city_field_change('city_from', e.target.value, autocomplite_data))}
                />
                <div className="front-calc__city_remove"
                    onClick={() => dispatch(city_field_change('city_from', '', ''))} />
                {
                    autocomplite.length > 0 && (
                        <div id="city_fromautocomplete-list" className="autocomplete-items">
                            <div>
                                {
                                    autocomplite.map((item, index) => (
                                        <div key={index}
                                             onClick={(e) => dispatch(city_field_change('city_from', item, []))}>
                                            {item}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    )
                }
            </div>
        </React.Fragment>
    )
}